import { AddEventToWebengageType } from "@website/tracking/tracking.types";
import { getChannel } from "@website/utils/channel/get-channel";
import { Channels } from "@website/utils/channel/types";
import { isSSR } from "@website/utils/is-ssr";

const mapEventPrefix: Record<string, string> = {
  b2b: "b2b"
};

export const addEventToWebengage: AddEventToWebengageType = (event, data) => {
  if (isSSR()) return;
  if (!window.webengage) {
    return setTimeout(() => addEventToWebengage(event, data), 1000);
  }

  const channel = getChannel();
  const mappedPrefix = mapEventPrefix[channel as Channels];
  window.webengage.track(mappedPrefix ? `${mappedPrefix}-${event}` : event, {
    ...data,
    channel: channel,
    Channel: channel
  });
};
